<script setup>
 const contactMail = 'dpd@inforserveis.es';

</script>
<template>
    <div class="privacy-data-wrapper">
      <article class="privacy-data-title">
        {{ $t('data_privacy.title') }}
      </article>
      <article class="privacy-data-block">
        <div class="privacy-data-subtitle">
          {{ $t('data_privacy.subtitle_0') }}
        </div>
        <div class="privacy-data-text-2">
          {{ $t('data_privacy.text_0') }}
        </div>
      </article>
      <article class="privacy-data-block">
        <div class="privacy-data-subtitle">
          {{ $t('data_privacy.subtitle_1') }}
        </div>
        <div class="privacy-data-text-2">
          {{ $t('data_privacy.text_1') }}
        </div>
      </article>
      <article class="privacy-data-block">
        <div class="privacy-data-subtitle">
          {{ $t('data_privacy.subtitle_2') }}
        </div>
        <div class="privacy-data-text-2">
          {{ $t('data_privacy.text_2') }}
        </div>
      </article>
      <article class="privacy-data-block">
        <div class="privacy-data-subtitle">
          {{ $t('data_privacy.subtitle_3') }}
        </div>
        <div class="privacy-data-text-2">
          {{ $t('data_privacy.text_3') }}
        </div>
      </article>
      <article class="privacy-data-block">
        <div class="privacy-data-subtitle">
          {{ $t('data_privacy.subtitle_4') }}
        </div>
        <div class="privacy-data-text-2">
          {{ $t('data_privacy.text_4').replace('##CONTACT_MAIL##', contactMail) }}
          <a href="https://www.aepd.es" target="_blank">(www.aepd.es)</a>
        </div>
      </article>
    </div>
</template>
  
  <style lang="scss" scoped>
  .privacy-data-wrapper {
    padding-top: 90px;
    padding-bottom: 230px;
    max-width: 990px;
    margin: 0 auto;
    .privacy-data-title {
      font-size: 60px;
      letter-spacing: -3px;
      font-family: 'CircularStd-Black';
      padding-bottom: 55px;
    }
    .privacy-data-block {
      font-size: 18px;
      letter-spacing: -0.9px;
      padding-bottom: 7px;
      .privacy-data-subtitle {
        font-size: 30px;
        letter-spacing: -1.5px;
        font-family: 'CircularStd-Bold';
        padding-bottom: 10px;
      }
      .privacy-data-text-1 {
        padding-bottom: 0px;
      }
      .privacy-data-text-2 {
        padding-bottom: 25px;
      }
      a {
        color: #0047ba;
        text-decoration: none;
        position: relative;
      }
      a:before {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        border-radius: 4px;
        background-color: #0047ba;
        bottom: -2px;
        left: 0;
        transform-origin: right;
        transform: scaleX(0);
        transition: transform 0.3s ease-in-out;
      }
      a:hover:before {
        transform-origin: left;
        transform: scaleX(1);
      }
    }
  }
  </style>